import React, { PropTypes } from "react";

export default class CollectionPointView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showOpeningsHours: false };
    }

    render() {
        return (
          <div className="shop-info row clearfix">
            <div className="col-xs-9">
              <h3>{this.props.name}</h3>
              {this.props.address != undefined &&
                  <div className="address">
                      {this.props.address.street} {this.props.address.number} {this.props.address.box}<br />
                      {this.props.address.postalCode} {this.props.address.city}
                  </div>
              }
            </div>
            <div className="col-xs-3 text-right">
              {!this.props.active ?
                <button className="btn btn-default" onClick={this.props.onChange}>Select</button> :
                <span className="alert alert-success">Selected</span>
              }
            </div>

            {
                    this.props.openingHours && this.state.showOpeningsHours ?
                      <div className="col-xs-7 col-md-8">
                        <h4>Openingsuren</h4>
                        <div className="openinghours">
                          <table>
                            <tbody>
                              {this.props.openingHours.map((openingHour, index) => (
                                <tr key={index}>
                                  <td className="day">{openingHour.weekday}</td>
                                  <td className="time">{openingHour.openMorning} - {openingHour.closeMorning}</td>
                                  <td className="time">{openingHour.openAfternoon} - {openingHour.closeAfternoon}</td>
                                </tr>
                                    ))}
                            </tbody>
                          </table>
                        </div>
                      </div> :
                    null
                }
          </div>
        );
    }
}

CollectionPointView.propTypes = {
    name: PropTypes.string,
    address: PropTypes.shape({
        street: PropTypes.string,
        number: PropTypes.string,
        box: PropTypes.string,
        postalCode: PropTypes.string,
        city: PropTypes.string,
    }).isRequired,
    openingHours: PropTypes.arrayOf(PropTypes.shape({
        weekday: PropTypes.string,
        openMorning: PropTypes.string,
        closeMorning: PropTypes.string,
        openAfternoon: PropTypes.string,
        closeAfternoon: PropTypes.string,
    })),
    active: PropTypes.bool,
    onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Checkout/Views/CollectionPointView.jsx